module.exports = new __parcel__URL__("mainframe_level_9.c5d6a08e.png").toString();